import * as Types from '@/types';

import { gql } from '@apollo/client';
export const SalesPortalRestaurantFieldsFragmentDoc = gql`
  fragment SalesPortalRestaurantFields on businesses {
    uuid
    name
    address {
      address
      timezone
      uuid
    }
  }
`;
export const SalesPortalSupplierFieldsFragmentDoc = gql`
  fragment SalesPortalSupplierFields on businesses {
    uuid
    address {
      uuid
      timezone
      country_code
    }
  }
`;
